export type CancelConfirmDialogProps = {
  readonly message: string
  readonly subtext?: string
  readonly yesLabel: string
  readonly noLabel: string
  readonly onConfirm: () => void
  readonly onDismiss: () => void
}

export default function CancelConfirmDialog({
  message,
  subtext,
  yesLabel,
  noLabel,
  onConfirm,
  onDismiss,
}: CancelConfirmDialogProps) {
  return (
    <div className="cop-modal-confirm-overlay" role="dialog" aria-modal="true" aria-labelledby="cop-confirm-title">
      <div className="cop-modal-confirm">
        <div className="cop-modal-confirm__header">
          <h3 id="cop-confirm-title" className="cop-modal-confirm__title">{message}</h3>
          <button
            type="button"
            className="cop-modal-confirm__close"
            aria-label="Close"
            onClick={onDismiss}
          >
            &times;
          </button>
        </div>
        {subtext && <p className="cop-modal-confirm__subtext">{subtext}</p>}
        <hr className="cop-modal-confirm__divider" />
        <div className="cop-modal-confirm__actions">
          <button
            type="button"
            className="cop-modal__btn cop-modal__btn--share"
            onClick={onConfirm}
          >
            {yesLabel}
          </button>
          <button
            type="button"
            className="cop-modal__btn cop-modal__btn--cancel"
            onClick={onDismiss}
          >
            {noLabel}
          </button>
        </div>
      </div>
    </div>
  )
}
